import moengage from '@moengage/web-sdk';
import SECRETS from 'src/common/secrets';

const moEngageUtils = {
  initializeMoEngage: () => {
    // TODO
    moengage?.initialize({
      app_id: process.env.REACT_APP_MO_ENGAGE_APP_ID || SECRETS.REACT_APP_MO_ENGAGE_APP_ID as string,
      cluster: process.env.REACT_APP_MO_ENGAGE_DATA_CENTER || SECRETS.REACT_APP_MO_ENGAGE_DATA_CENTER as string,
      debug_logs: parseInt(process.env.REACT_APP_MO_ENGAGE_ENABLE_DEBUG_LOGS || String(SECRETS.REACT_APP_MO_ENGAGE_ENABLE_DEBUG_LOGS)),
    });
  },

  trackEvent: (eventName: string, eventData = {}) => {
    moengage?.track_event(eventName, eventData);
  },

  setUserAttributes: (attributes: any) => {
    try {
      if (window?.Moengage) {
        const { user_id, first_name = '', last_name = '', mobile, email, ...attr } = attributes;

        window.Moengage?.add_unique_user_id(user_id);
        window.Moengage?.add_user_name(first_name + ' ' + last_name);
        window.Moengage?.add_email(email);
        window.Moengage?.add_mobile(mobile);

        for (const [key, value] of Object.entries(attr)) {
          window?.Moengage?.add_user_attribute(key, value);
        }
      } else {
        throw new Error('MoEngage is not initialized. Make sure to call initializeMoEngage first.');
      }
    } catch (error) {
      console.error('Error while setting user attributes:', error);
      throw error;
    }
  },

  logout: () => {
    window?.Moengage?.destroy_session();
  },
}

export default moEngageUtils;